<hpf-credit-form
        [credit]="credit"
        [loading]="credit.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-credit-form>
